import React, { useCallback } from "react"
import BSForm from "react-bootstrap/Form"
import format from "date-fns/format"
import { useLanguageState } from "../../globalStates/LanguageState"
import BSFormControl from "react-bootstrap/FormControl"
import DateTimePicker from "../DateTimePicker"
import InputField, { FeedbackInput } from "./InputField"
import moment from "moment"

interface DateTimeFieldProps extends FeedbackInput {
    id: string
    name: string
    label: string
    placeholder?: string
    required?: boolean
    value?: Date
    onChange?: (date: Date) => void
}

const DateTimeFieldI: React.FC<DateTimeFieldProps> = ({ id, name, label, placeholder, required, value, error, onChange }) => {
    const branding = useLanguageState().getStrings()
    const date = typeof value === "string" ? moment(value).toDate() : value

    const onChangeLocal = useCallback(
        (date) => {
            onChange?.(date)
        },
        [onChange]
    )

    return (
        <BSForm.Group>
            <BSForm.Label>
                {label}
                {required ? "*" : ""}
            </BSForm.Label>
            <DateTimePicker
                id={id}
                placeholderText={placeholder || branding.configuration.dateFormat}
                dateFormat={branding.configuration.dateFormat}
                timeFormat={branding.configuration.timeFormat}
                initialDate={date}
                customInput={
                    <BSForm.Control
                        name={name}
                        value={date && format(date, branding.configuration.dateFormat)}
                        maxLength={19}
                        isValid={!error}
                        isInvalid={!!error}
                    />
                }
                onChange={onChangeLocal}
            />
            {/* TODO - remvoe workaround by provind a proper input control next to the feedback*/}
            <BSFormControl.Feedback type="invalid" style={{ display: !!error ? "block" : "none" }}>
                {error}
            </BSFormControl.Feedback>
        </BSForm.Group>
    )
}

const DateTimeField = (props: any) => <InputField component={DateTimeFieldI} {...props} />
export default DateTimeField
